/** Route chunks may mount after the router effect; always read the current layout. */
export function bindPageLayout() {
  let frame = null;
  let keyboardTimer = null;
  let previousScroll = window.scrollY;
  let keyboardOpen = false;

  const modifiers = () => {
    const container = document.querySelector(".container");
    if (!container) return;
    const bottom = document.querySelector(".tab-bar-nav.fixed");
    container.classList.toggle("has-top-bar", !!document.querySelector(".top-bar"));
    container.classList.toggle("has-bottom-tab-nav", !!bottom && !bottom.classList.contains("slide-down"));
    container.classList.toggle("has-bottom-btn-group", !!document.querySelector(".tab-bar-btn-group.fixed"));
    container.classList.toggle("modal-open", !!document.querySelector(".modal-dimmed.is-show"));
  };

  const update = () => {
    frame = null;
    const page = document.querySelector(".page");
    const top = document.querySelector(".top-bar");
    const bottom = document.querySelector(".tab-bar-nav");
    const floating = document.querySelector(".floating-wrap");
    const scroll = window.scrollY;
    if (page && top) {
      let threshold;
      if (page.id === "main") threshold = 154;
      else if (page.id === "my_page") threshold = document.querySelector(".top-content")?.clientHeight;
      if (threshold !== undefined) {
        top.classList.toggle("bg-white", scroll > threshold);
        top.classList.toggle("bg-primary", scroll <= threshold);
      } else if (document.querySelector(".content-wrap")?.classList.contains("bg-gradient")) {
        top.classList.toggle("bg-white", scroll > 40);
      }
    }
    if (page && bottom && floating) {
      if (keyboardOpen) floating.style.display = "none";
      else {
        floating.style.display = scroll === 0 ? "none" : "flex";
        bottom.classList.toggle("slide-down", document.body.scrollHeight >= window.innerHeight * 2 && scroll > previousScroll);
      }
    }
    previousScroll = scroll;
    modifiers();
  };

  const schedule = () => {
    if (frame === null) frame = requestAnimationFrame(update);
  };
  const input = (target) => target?.tagName === "TEXTAREA" ||
    (target?.tagName === "INPUT" && ["text", "search", "tel", "email", "password", "number", "url"].includes(target.type));
  const focusIn = (event) => {
    if (input(event.target)) {
      keyboardOpen = true;
      clearTimeout(keyboardTimer);
      document.querySelector(".tab-bar-nav")?.classList.add("hidden");
    }
    schedule();
  };
  const focusOut = (event) => {
    if (input(event.target)) {
      keyboardOpen = false;
      clearTimeout(keyboardTimer);
      keyboardTimer = setTimeout(() => {
        if (!keyboardOpen) document.querySelector(".tab-bar-nav")?.classList.remove("hidden");
        schedule();
      }, 200);
    }
    schedule();
  };

  update();
  // Observe mounts/removals, including Suspense resolution; our class changes cannot loop this observer.
  const observer = new MutationObserver((changes) => {
    if (changes.some((change) => change.type === "childList" || change.target.matches?.(".modal-dimmed"))) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
  window.addEventListener("scroll", schedule, { passive: true });
  document.addEventListener("focusin", focusIn);
  document.addEventListener("focusout", focusOut);
  return () => {
    observer.disconnect();
    window.removeEventListener("scroll", schedule);
    document.removeEventListener("focusin", focusIn);
    document.removeEventListener("focusout", focusOut);
    if (frame !== null) cancelAnimationFrame(frame);
    clearTimeout(keyboardTimer);
    document.querySelector(".tab-bar-nav")?.classList.remove("hidden");
  };
}
